import { cn } from "@/lib/utils";
import { 
  UserPlus, 
  Calendar, 
  QrCode, 
  DollarSign, 
  Settings, 
  AlertCircle,
  CheckCircle,
  XCircle,
  Clock
} from "lucide-react";

const iconMap = {
  'user-add': UserPlus,
  'event': Calendar,
  'scan': QrCode,
  'payment': DollarSign,
  'settings': Settings,
  'alert': AlertCircle,
  'success': CheckCircle,
  'error': XCircle,
  'pending': Clock,
};

const iconColors = {
  'user-add': 'text-electric-ice-blue',
  'event': 'text-cool-mint',
  'scan': 'text-soft-amber',
  'payment': 'text-cool-mint',
  'settings': 'text-soft-silver',
  'alert': 'text-soft-amber',
  'success': 'text-cool-mint',
  'error': 'text-signal-red',
  'pending': 'text-soft-amber',
};

export const ActivityItem = ({ 
  icon = 'event',
  text, 
  timestamp,
  className 
}) => {
  const Icon = iconMap[icon] || Calendar;
  const iconColor = iconColors[icon] || 'text-soft-silver';
  
  return (
    <div 
      className={cn(
        "flex items-start gap-3 py-3 border-b border-white/[0.06] last:border-0",
        className
      )}
      data-testid="activity-item"
    >
      <div className={cn(
        "w-8 h-8 rounded-lg bg-white/[0.05] flex items-center justify-center flex-shrink-0",
        iconColor
      )}>
        <Icon className="w-4 h-4" />
      </div>
      
      <div className="flex-1 min-w-0">
        <p className="text-sm text-soft-silver">{text}</p>
        <span className="text-xs text-muted-text font-mono">{timestamp}</span>
      </div>
    </div>
  );
};

export const ActivityFeed = ({ 
  items = [], 
  title = "Recent Activity",
  className 
}) => {
  return (
    <div 
      className={cn(
        "bg-graphite rounded-xl border border-white/[0.06] p-5",
        className
      )}
      data-testid="activity-feed"
    >
      <h3 className="text-lg font-medium text-cloud-white mb-4">{title}</h3>
      <div className="space-y-0">
        {items.map((item, index) => (
          <ActivityItem key={index} {...item} />
        ))}
        {items.length === 0 && (
          <p className="text-sm text-muted-text text-center py-4">No recent activity</p>
        )}
      </div>
    </div>
  );
};

export default ActivityFeed;
